import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserdebuginfoService extends BaseService {
  readonly BASE_URL = `${environment.gatewayAPI_V1}/users/`;

  constructor(private httpClient: HttpClient) {
      super();
  }

  public updateRegisterStatus(debugInfo: string): Observable<boolean> {
      const url = `${this.BASE_URL}userdebuginfos/adduserdebuginfo`;
      //const url = `https://localhost:7284/api/v1/userdebuginfos/adduserdebuginfo`;
      return this.httpClient.post<boolean>(url,  JSON.stringify(debugInfo)).pipe(
          tap(_ => _),
          catchError(this.handleError));
  }
}
